import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, ready } = useAuth();

  if (!ready || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ksy-bg" data-testid="auth-loading">
        <Loader2 className="w-8 h-8 text-ksy-blue animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "admin" ? "/admin" : user.role === "partner" ? "/partner/dashboard" : "/dashboard";
    return <Navigate to={home} replace />;
  }
  return children;
}
